import { customCleanEnv, url } from "envalid";

interface Env {
    trainingSessionBaseUrl: string;
    expertUniversityEvaluationApiUrl: string;
    liveKitSessionApiBaseUrl: string;
}

export const env = customCleanEnv(
    import.meta.env,
    {
        VITE_TRAINING_SESSION_API_BASE_URL: url(),
        VITE_EXPERT_UNIVERSITY_EVALUATION_API_URL: url(),
        VITE_LIVEKIT_SESSION_API_BASE_URL: url(),
    },
    (inputEnv): Env => ({
        trainingSessionBaseUrl: inputEnv.VITE_TRAINING_SESSION_API_BASE_URL,
        expertUniversityEvaluationApiUrl: inputEnv.VITE_EXPERT_UNIVERSITY_EVALUATION_API_URL,
        liveKitSessionApiBaseUrl: inputEnv.VITE_LIVEKIT_SESSION_API_BASE_URL,
    }),
);
